import classNames from 'classnames';
import React from 'react';
import CheckSvg from 'images/v5/icons/check.svg';
import styles from './ColorDot.module.scss';
function ColorDot({ color = 'var(--status-color-neutral)', size = 's', check = false, draft = false, }) {
    if (check) {
        return (React.createElement("span", { className: classNames(styles.dot, styles[size], styles.check), style: { ['--dot-color']: color } },
            React.createElement(CheckSvg, null)));
    }
    return (React.createElement("span", { className: classNames(styles.dot, styles[size], {
            [styles.draft]: draft,
        }), style: draft ? undefined : { ['--dot-color']: color } }));
}
export default ColorDot;
